import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { testimonials } from '../../data/content';
export function TestimonialsSection() {
  return <section className="bg-white py-14 sm:py-20" aria-labelledby="testimonials-title" data-id="element-296" data-mp="1rtuxr8asr3i9">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-297" data-mp="1mw1r6e5l07hg">
        <SectionHeading eyebrow="What other physicians are saying" title={<span id="testimonials-title" data-id="element-299" data-mp="1dvdbzg4gc12z">
              Physicians who chose to bring a system into their clinical decision-making process
            </span>} data-id="element-298" data-mp="1ivizck3ov1f9" />

        <ul className="mt-9 grid gap-5 md:grid-cols-3" data-id="element-300" data-mp="13xqkzv9voj2n">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-3xl border border-navy-100 bg-navy-50/60 p-5" data-id="element-301" data-mp="33akwk6cw4t1u">
              <QuoteIcon className="h-6 w-6 shrink-0 text-clinic-500" aria-hidden="true" data-id="element-302" data-mp="2y9nfjx3ma51x" />
              <blockquote className="mt-3 flex-1 text-[14.5px] font-medium leading-relaxed text-navy-800 sm:text-[15px]" data-id="element-303" data-mp="1t8bzy1gxcgm8">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-304" data-mp="1jd0l7j5in9eh">
                <img src={testimonial.image} alt={`Portrait of ${testimonial.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-clinic-500/40" loading="lazy" data-id="element-305" data-mp="1obbw7x7jrpya" />
                <div className="min-w-0" data-id="element-306" data-mp="22auzabli4b3q">
                  <p className="truncate text-[14px] font-black text-navy-900" data-id="element-307" data-mp="22a1sjamjllll">{testimonial.name}</p>
                  <p className="truncate text-[12.5px] font-semibold text-navy-500" data-id="element-308" data-mp="277liv8wilotw">
                    {testimonial.country}
                  </p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-309" data-mp="2zq8zab0kgfon">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-[#f5a524] text-[#f5a524]" aria-hidden="true" data-id="element-310" data-mp="39kwm4ptqn04h" data-mpi={i} />)}
                  </div>
                </div>
              </div>
            </li>)}
        </ul>

        <CtaBlock kicker="Join the physicians who are choosing to stop improvising and start using a structured system." label="👉 I want the same structured approach" data-id="element-311" data-mp="2qmk0w5pjxzsj" />
      </div>
    </section>;
}